import { useRecoilValue } from "recoil";
import CBSearchAutocompleteController from "../controller/CBSearchAutocompleteController";
import { sapEnumState } from "../../../state/customerbaseState";
import { useFormContext } from "react-hook-form";
import { CustomerSearchFilters } from "../../../types";

const CBDossierStatusSearchFilter = () => {

    const sapEnum = useRecoilValue(sapEnumState);
    const formContext = useFormContext<CustomerSearchFilters>();
    
    return (
        <CBSearchAutocompleteController 
            idField="dossierStatus"
            formName="dossierStatus"
            label="dossierStatus"
            translateLabel="sapEnum.dossierStatus"
            options={sapEnum.dossierStatus}
            onChange={(value) => formContext.setValue("dossierStatus", value? value.value : "")}
        />
    )

}

export default CBDossierStatusSearchFilter;